import React, { useState, useEffect } from 'react'
import { useLocation } from "react-router-dom";
import { Container, Card, Row, Col, Form, Button } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';

import axios from "axios";

const AddLevel = () => {
    const userData = sessionStorage.getItem('user');
    const userObj = userData ? JSON.parse(userData) : {};
    const [editId, setEditId] = useState(null);
    const [levels, setlevels] = useState([]);
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const routeLocation = useLocation();
    const [form, setForm] = useState({
        level_id: "",
        description: "",
        school_id: "",
    });

    useEffect(() => {
        if (routeLocation.state?.levelsData) {
            const levelsData = routeLocation.state.levelsData;
            setForm(levelsData);
            setEditId(levelsData.level_id);
        }
    }, [routeLocation]);


    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setForm((prevForm) => ({
            ...prevForm,
            [id]: value
        }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = {
            description: form.description,
            school_id: userObj.school_id,
            is_active: form.is_active || "A",
            action: editId !== null ? 'UPDATE' : 'CREATE',
        };

        if (editId !== null) {
            formData.level_id = editId;
        }

        try {
            const response = await axios.post(baseUrl + "/level/", formData, {
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (editId !== null) {
                toast.success("Record Updated Successfully");
                setEditId(null);
            } else {
                toast.success("Record Added Successfully");
            }

            setForm({
                description: "",
                level_id: "",
            });

        } catch (error) {
            console.log("Full error object:", error);

            if (error.response) {
                const { status, data } = error.response;
                const errorMessage = data.error || data.message || "Unexpected error occurred";

                if (status === 409 && errorMessage.includes("Record already exists")) {
                    toast.error("Record already exists.", { position: "top-right" });
                } else if (status === 500) {
                    toast.error("Error submitting data: " + errorMessage, { position: "top-right" });
                } else {
                    toast.error("Unexpected error occurred", { position: "top-right" });
                }
            } else {
                toast.error("Error submitting data: " + error.message, { position: "top-right" });
            }
        }
    };
    return (

                <div className='pageBody'>
                    <ToastContainer />
                    <Container fluid>
                        <Card>
                            <Card.Body>
                                <form onSubmit={handleSubmit}>
                                    <Row>
                                        <Col xs={12}>
                                            <h6 className='commonSectionTitle'>Level Details</h6>
                                        </Col>

                                    </Row>
                                    <Row>

                                        <Col xs={12} md={6} lg={4} xxl={3}>
                                            <div className='commonInput'>
                                                <Form.Group>
                                                    <Form.Label>
                                                        Level Name <span className='requiredStar'>*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="text"
                                                        id="description"
                                                        value={form.description}
                                                        placeholder="Enter Level Name"
                                                        maxLength={30}
                                                        onChange={handleInputChange}
                                                        onKeyDown={(e) => {
                                                            if (e.key === ' ' && e.target.selectionStart === 0) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                    />

                                                </Form.Group>
                                            </div>
                                        </Col>

                                    </Row>
                                    <div className="d-flex justify-content-between mt-3">
                                        <div>
                                            <Button
                                                type="button"
                                                variant="primary"
                                                className="btn-info clearBtn"
                                                onClick={() => setForm({
                                                    level_id: "",
                                                    description: "",
                                                    is_active: "A",

                                                })}

                                            >
                                                Reset
                                            </Button>
                                        </div>
                                        <div>
                                            <Button
                                                type="button"
                                                variant="primary"
                                                className="btn-danger secondaryBtn me-2"
                                                onClick={() => window.history.back()}
                                            >
                                                Cancel
                                            </Button>
                                            <Button
                                                type="submit"
                                                variant="primary"
                                                className="btn-success primaryBtn"
                                            >
                                                Submit
                                            </Button>
                                        </div>
                                    </div>
                                </form>
                            </Card.Body>
                        </Card>
                    </Container>
                
        </div>

    );
};

export default AddLevel;